import React from 'react';

export const RoomName = ({room}) => {
    return <>{`${room?.name} - ${room?.motel.name}`}</>;
};
